import React, { useState } from 'react';
import { Search, MapPin } from 'lucide-react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [location, setLocation] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (searchTerm) params.append('search', searchTerm);
    if (location) params.append('location', location);
    navigate(`/?${params.toString()}`);
    setTimeout(() => {
      document.getElementById('conferences-list')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <div className="relative bg-black">
      <div
        className="absolute inset-0 opacity-60"
        style={{
          backgroundImage:
            'url(/hero-seo.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />
      <div className="relative container mx-auto px-4 py-24 md:py-32">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-cyan-400 text-xs uppercase tracking-widest mb-4 font-semibold">
            The World's Best SEO Conferences
          </p>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Discover Your Next{' '}
            <span className="text-cyan-400">
              SEO Event
            </span>
          </h1>
          <p className="text-gray-300 text-lg md:text-xl mb-12">
            Browse top-rated technical SEO summits, content strategy workshops,
            and digital marketing networking events.
          </p>

          <form onSubmit={handleSearch} className="max-w-3xl mx-auto">
            <div className="flex flex-col md:flex-row gap-3 bg-gray-900/80 backdrop-blur-sm p-2 rounded-xl">
              <div className="flex-1 relative">
                <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <Input
                  type="text"
                  placeholder="Search by name or topic"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-12 h-12 bg-gray-800 border-0 text-white placeholder:text-gray-500 rounded-lg focus:ring-2 focus:ring-purple-500"
                />
              </div>
              <div className="flex-1 relative">
                <MapPin className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <Input
                  type="text"
                  placeholder="Location (e.g. London)"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                  className="pl-12 h-12 bg-gray-800 border-0 text-white placeholder:text-gray-500 rounded-lg focus:ring-2 focus:ring-purple-500"
                />
              </div>
              <Button
                type="submit"
                className="h-12 px-10 bg-purple-600 hover:bg-purple-700 text-white font-semibold rounded-lg shadow-lg"
              >
                Search
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Hero;
